import { render } from "./PostedBlogs.vue?vue&type=template&id=130696f8&scoped=true"
import script from "./PostedBlogs.vue?vue&type=script&lang=js"
export * from "./PostedBlogs.vue?vue&type=script&lang=js"

import "./PostedBlogs.vue?vue&type=style&index=0&id=130696f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130696f8"]])

export default __exports__